import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, requireRole }) => {
  const { currentUser, userRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  // ✅ Check if user has wrong role and redirect to correct dashboard
  if (requireRole && userRole !== requireRole) {
    // If they need counselor role but are couple, send to couple dashboard
    if (requireRole === 'counselor' && userRole === 'couple') {
      return <Navigate to="/couple/dashboard" replace />;
    }
    // If they need couple role but are counselor, send to counselor dashboard
    if (requireRole === 'couple' && userRole === 'counselor') {
      return <Navigate to="/counselor/dashboard" replace />;
    }
    // Otherwise, send home
    return <Navigate to="/" replace />;
  }

  return children;
};